import React, { FunctionComponent, useCallback } from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Button,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Translation from '../../../../../common/components/presentation/Translation/Translation';
import termsAndConditionModalStyles from './termsAndConditionsModalStyles';

type TermsAndConditionsModalProps = {
  isOpen: boolean;
  setIsOpen: (newValue: boolean) => void;
  setIsAccepted: (newValue: boolean) => void;
};

const TermsAndConditionsModal: FunctionComponent<TermsAndConditionsModalProps> = ({
  isOpen,
  setIsOpen,
  setIsAccepted,
}) => {
  const styles = termsAndConditionModalStyles();

  const handleAccept = useCallback(() => {
    setIsAccepted(true);
    setIsOpen(false);
  }, [setIsAccepted, setIsOpen]);

  return (
    <Dialog
      open={isOpen}
      className={styles.dialog}
      classes={{
        paper: styles.dialogPaper,
      }}
      data-test={'checkout:identityVerification:terms:modal'}
    >
      <DialogTitle className={styles.dialogTitle}>
        <Box className={styles.dialogTitleContent}>
          <Typography variant={'h4'}>
            <Translation id={'trans__insurance__insapp_scan_singpass__modal_title_label'} />
          </Typography>
          <IconButton
            className={styles.iconButton}
            onClick={() => setIsOpen(false)}
            data-test={'checkout:identityVerification:terms:modal:close'}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent className={styles.dialogContent}>
        <Typography className={styles.disclaimerText}>
          <Translation id={'trans__checkout__next_step__customer_information__singpass_disclaimer1'} />
        </Typography>
        <Typography className={styles.disclaimerText}>
          <Translation id={'trans__checkout__next_step__customer_information__singpass_disclaimer2'} />
        </Typography>
        <Typography className={styles.disclaimerText}>
          <Translation id={'trans__checkout__next_step__customer_information__singpass_disclaimer3'} />
        </Typography>
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <Button
          color="primary"
          variant="contained"
          className={styles.acceptButton}
          onClick={handleAccept}
          data-test={'checkout:identityVerification:terms:modal:accept'}
        >
          <Typography variant={'caption'}>
            <Translation id={'trans__insurance__insapp_scan_singpass__modal_cta_label'} />
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsAndConditionsModal;
